import fetch from 'auth/GenericFetchInterceptor'

const RoleService = {}


RoleService.getUsers = function () {
    return fetch({
        url: `/api/users?populate[binding_roles][populate][0]=store&populate[role]=*&populate[foto_profilo]=*`,
        method: 'GET'
    })
}

RoleService.getUsersWithFoto = function () {
    return fetch({
        url: `/api/users?populate[binding_roles][populate][0]=store&populate=foto_profilo`,
        method: 'GET'
    })
}

RoleService.getBindingRoles = function () {
    return fetch({
        url: `/api/binding-roles?populate=*`,
        method: 'GET'
    })
}

RoleService.getBindingRolesCompanyStores = function () {
    return fetch({
        url: `/api/binding-role-company-stores?populate=*`,
        method: 'GET'
    })
}

RoleService.getBindingRolesCompanyStoresFilters = function (queryString) {
    return fetch({
        url: `/api/binding-role-company-stores?populate=store${queryString}`,
        method: 'GET'
    })
}

RoleService.getBindingRolesUserCompanies = function () {
    return fetch({
        url: `/api/binding-role-user-companies?populate=*`,
        method: 'GET'
    })
}

RoleService.getUsersRoles = function () {
    return fetch({
        url: `/api/users-permissions/roles`,
        method: 'GET'
    })
}

RoleService.createBindingRole = function (data) {
    return fetch({
        url: `/api/binding-roles`,
        method: 'POST',
        data: data
    })
}

RoleService.createUser = function (data) {
    return fetch({
        url: `/api/users`,
        method: 'POST',
        data: data
    })
}

RoleService.changePassword = function (data) {
    return fetch({
        url: `/api/auth/change-password`,
        method: 'POST',
        data: data
    })
}

RoleService.updateUser = function (data, id) {
    return fetch({
        url: `/api/users/${id}`,
        method: 'PUT',
        data: data
    })
}

RoleService.updateBindingRole = function (data, id) {
    return fetch({
        url: `/api/binding-roles/${id}`,
        method: 'PUT',
        data: data
    })
}

RoleService.createBindingRoleCompanyStore = function (data) {
    return fetch({
        url: `/api/binding-role-company-stores`,
        method: 'POST',
        data: data
    })
}

RoleService.createBindingRoleUserCompanies = function (data) {
    return fetch({
        url: `/api/binding-role-user-companies`,
        method: 'POST',
        data: data
    })
}


RoleService.updateBindingRoleCompanyStore = function (data, id) {
    return fetch({
        url: `/api/binding-role-company-stores/${id}`,
        method: 'PUT',
        data: data
    })
}

RoleService.deleteBindingRoleCompanyStore = function (id) {
    return fetch({
        url: `/api/binding-role-company-stores/${id}`,
        method: 'DELETE'
    })
}

RoleService.deleteBindingRole = function (id) {
    return fetch({
        url: `/api/binding-roles/${id}`,
        method: 'DELETE'
    })
}

RoleService.deletBindingRoleUserCompanies = function (id) {
    return fetch({
        url: `/api/binding-role-user-companies/${id}`,
        method: 'DELETE'
    })
}

export default RoleService;